import { useStateWithCallback } from '@dni-react-hooks/use-state-with-callback'
import { type CarouselProps } from './Carousel'

interface UsePagingReturnType {
  currentPage: number
  goToPage: (index: number) => void
  goForward: () => void
  goBack: () => void
}

export type OnPageChange = (page: number) => void

interface PagingProps {
  totalPages: number
  wrapMode: CarouselProps['wrapMode']
  onPageChange?: OnPageChange
}

export function usePaging({
  totalPages,
  wrapMode,
  onPageChange,
}: PagingProps): UsePagingReturnType {
  const [currentPage, setCurrentPage] = useStateWithCallback(0)

  const goToPage = (index: number) => {
    if (index < 0 || index >= totalPages) return
    setCurrentPage(index, onPageChange)
  }

  const goForward = () => {
    if (wrapMode === 'wrap') {
      setCurrentPage(prev => (prev + 1) % totalPages, onPageChange)
    }
    else {
      setCurrentPage(prev => Math.min(prev + 1, totalPages - 1), onPageChange)
    }
  }

  const goBack = () => {
    if (wrapMode === 'wrap') {
      setCurrentPage(prev => (prev - 1 + totalPages) % totalPages, onPageChange)
    }
    else {
      setCurrentPage(prev => Math.max(prev - 1, 0), onPageChange)
    }
  }

  return { currentPage, goToPage, goForward, goBack }
}
